/* eslint-disable @typescript-eslint/no-unused-vars */
export default {
  doubleDigits(val) {
    return val.toString().length < 2 ? `0${val}` : val
  },
  format(date, format, utc) {
    const dateTime = utc ? `${this.removeOffset(date)}-00:00` : date
    const utcDate = new Date(dateTime)
    const formattedDate = format

    return this.replace(utcDate, formattedDate)
  },
  getDateTime(value) {
    let date
    let time

    try {
      return ([date, time] = value.split('T'))
    } catch (e) {
      //
    }

    return [value, null]
  },
  getHour(date, utc) {
    const dateTime = utc ? `${this.removeOffset(date)}-00:00` : date
    let hour = this.format(dateTime, 'HH', utc)
    if (hour > 12) {
      hour = this.doubleDigits(hour - 12)
    } else if (hour === '00') {
      hour = '12'
    }
    return hour.toString()
  },
  get24Hour(hour, meridiem) {
    let hour24 =
      meridiem === 'pm'
        ? parseInt(hour) + 12
        : parseInt(hour) === 12
        ? '00'
        : hour
    if (hour24 === 24) {
      hour24 = 12
    }
    return hour24
  },
  getMonthName(month) {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    return monthNames[month]
  },
  getMonthShortName(month) {
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    return monthNames[month]
  },
  iso(value) {
    if (typeof value !== 'number') return value

    const iso = new Date(value * 1000).toISOString()
    let start = 11
    let end = 8

    if (iso.substr(start, 2) === '00') {
      start = 14
      end = 5
    }

    return iso.substr(start, end)
  },
  removeOffset(value) {
    let newDate = value
    let date
    let time

    try {
      ;[date, time] = value.split('T')
    } catch (e) {
      //
    }

    if (time) {
      const [currentTime] = time.split(/[-+Z]/gi)

      newDate = `${date}T${currentTime}`
    }

    return newDate
  },
  replace(date, formattedDate) {
    return formattedDate
      .replace(/\bm(?!m)/, date.getUTCMinutes())
      .replace(
        /\bM(?!M)/,
        date.getUTCMinutes() > 9
          ? date.getUTCMinutes()
          : `0${date.getUTCMinutes()}`
      )
      .replace(
        'h',
        date.getUTCHours() > 12
          ? date.getUTCHours() - 12
          : date.getUTCHours() === 0
          ? 12
          : date.getUTCHours()
      )
      .replace('HH', date.getUTCHours())
      .replace('DD', date.getUTCDate())
      .replace('YYYY', date.getUTCFullYear())
      .replace(/\ba(?!a)\b/, date.getUTCHours() >= 12 ? 'pm' : 'am')
      .replace(/\bA(?!A)\b/, date.getUTCHours() >= 12 ? 'PM' : 'AM')
      .replace('MMMM', this.getMonthName(date.getUTCMonth()))
      .replace('MMM', this.getMonthShortName(date.getUTCMonth()))
  },
  url(value) {
    let time =
      typeof value === 'number' ? this.iso(value).split(':') : value.split(':')

    time = time.map((t) => parseInt(t)).filter((t) => t >= 0)

    if (time.length === 3) {
      return `${time[0]}h${time[1]}m${time[2]}s`
    }
    if (time.length === 2) {
      return `${time[0]}m${time[1]}s`
    }

    if (time[0] >= 60) return this.url(time[0])

    return `${time[0]}s`
  },
}
